// extracted by mini-css-extract-plugin
module.exports = {"supportLink":"SupportLink-module__supportLink___1xPrI"};